import {
  ExtractFnReturnType,
  MutationConfigType,
  useMutation,
  UseMutationResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  id: string;
};

const request = async ({
  id,
}: RequestDataType): Promise<ResponseMessageType> => {
  const response = await new ApiClient().delete<ResponseMessageType>(
    `/api/managers/employee_condition_surveys/${id}`,
  );
  return response.data;
};

type MutationFnType = typeof request;

type PropsType = {
  config?: MutationConfigType<MutationFnType>;
};

export const useApisManagersEmployeeConditionSurveysDestroy = ({
  config = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation<ExtractFnReturnType<MutationFnType>, RequestDataType>(
    request,
    {
      ...config,
    },
  );
};
